import React from "react";
import { Divider } from "antd";
import { MailOutlined, PhoneOutlined } from "@ant-design/icons";
import "../../styles/components/divider.scss";

const ContactCenter = () => {
  return (
    <div className="contact-center">
      <Divider>Email</Divider>
      <a href="mailto:support@hamravesh.com">
        <MailOutlined />
        support@hamravesh.com
      </a>
      <Divider>Phone</Divider>
      <a href="call:+982192009240">
        <PhoneOutlined />
        +982192009240
      </a>
    </div>
  );
};

export default ContactCenter;
